import colors from '../foundations/colors';

const Input = {
   parts: ['field'],
   variants: {
      outline: {
         field: {
            bg: colors.white,
         },
      },
   },
};

export default Input;
